import React, { useEffect, useRef, useState } from 'react'
import { BsArrowRight } from 'react-icons/bs'
// import '../../layouts/stylesheets/insights-style.css';
import { sources } from '../Sources.jsx'

const InsightQuestions = (props) => {
  const [selectedIntegration, setSelectedIntegration] = useState('')
  const [textInterval, setTextInterval] = useState(null)
  const handleSelect = (event) => {
    setSelectedIntegration(event.target.id)
  }
  useEffect(() => {
    return () => {
      if (textInterval) {
        clearInterval(textInterval)
      }
    }
  }, [textInterval])

  const handleQuestion = (event) => {
    let i = 0
    let text = questions[event.target.id].question
    if (textInterval) {
      clearInterval(textInterval)
      setTextInterval(null)
    }
    askAwayRef.current.focus()
    let txtInterval = setInterval(() => {
      if (i !== text.length) {
        i += 1
        askAwayRef.current.blur()
        askAwayRef.current.setSelectionRange(i, i)
        askAwayRef.current.value = text.substr(0, i)
        askAwayRef.current.focus()
      } else {
        clearInterval(txtInterval)
        setTextInterval(null)
        props.changeProcess('response', {
          source: selectedIntegration,
          questionKey: event.target.id,
          question: text,
        })
      }
    }, 30)
    setTextInterval(txtInterval)
  }
  const askAwayRef = useRef()

  const questions = {
    highestClick_platform: {
      question: 'Which ad platform received the highest number of ad clicks?',
    },
    totalConversions_allCampaigns: {
      question:
        'What was the total number of conversions across all campaigns?',
    },
    highestConversion_device: {
      question: 'Which device had the highest number of conversions?',
    },
    mostConversion_day: {
      question: 'On which day did the campaign generate the most conversions?',
    },
    highestConversion_campaign: {
      question: 'Which campaign had the highest number of conversions?',
    },
    highestConversion_location: {
      question: 'Which location had the highest number of conversions?',
    },
    highestConversionRate_campaign: {
      question: 'Which campaign had the highest conversion rate?',
    },
    highestConversion_hour: {
      question:
        'During which start hour were the highest number of conversions recorded?',
    },
    averageConversionRate_allCampaigns: {
      question: 'What was the average conversion rate across all campaigns?',
    },
    highestConversionRate_device: {
      question: 'Which device had the highest conversion rate?',
    },
  }
  return (
    <div className="flex justify-center items-center h-[calc(100vh-100px)] overflow-y-scroll ml-4 pr-4 md:pr-16">
      <div className="h-full">
        <div className="mb-16 mt-6 text-center">
          <div className="inline-block px-1">
            <input
              id="empty"
              name="source"
              type="radio"
              className="insightsRadio hidden absolute"
            />
            <label
              htmlFor="empty"
              className="h-12 flex justify-center items-center text-white text-center rounded placeholder-black text-sm p-2.5 px-4 break-normal"
              style={{ background: '#491C96', opacity: '0.2' }}
            >
              <div className="h-8 w-8 mr-1"></div>
            </label>
          </div>
          {sources.map((s) => (
            <div className="inline-block px-1" key={s.id}>
              <input
                id={s.id}
                name="source"
                type="radio"
                className="insightsRadio hidden absolute"
                onClick={handleSelect}
              />
              <label
                htmlFor={s.id}
                className="h-12 flex justify-center items-center bg-gray-50 text-white text-center rounded placeholder-black text-sm py-2.5 px-4 break-normal"
              >
                <img className="h-8 mr-1" src={s.image} alt={s.id}></img>
                <span className="overflow-hidden w-0 whitespace-nowrap">
                  {s.name}
                </span>
              </label>
            </div>
          ))}
        </div>
        <div>
          <div>
            <div className="flex items-center mb-2">
              <p className="w-full font-semibold mx-auto font-unbounded">
                Ask M‑Sight (BETA)
              </p>
            </div>
            <p className="w-full text-2xl font-light text-[#000000] mx-auto mb-8">
              Rapid Answers for Your Outgoing Campaigns
            </p>
          </div>
          <div className="mb-8">
            {Object.keys(questions).map((q) => (
              <div className="mb-2 rounded-3xl" key={q}>
                <input
                  id={q}
                  name="insight"
                  type="radio"
                  className="insightsInput hidden absolute"
                  onClick={handleQuestion}
                />
                <label
                  htmlFor={q}
                  className="flex bg-[#F9FCF8] text-black font-light font-unbounded text-left rounded-3xl placeholder-black text-lg p-2.5 px-4 break-normal cursor-pointer w-full"
                >
                  <div className="mx-6">{questions[q].question}</div>
                  <BsArrowRight className="h-6 w-6 my-auto ml-auto"></BsArrowRight>
                </label>
              </div>
            ))}
          </div>
          <div className="flex rounded-2xl bg-gray-50 w-full h-20">
            <input
              id="askaway"
              ref={askAwayRef}
              className="bg-gray-50 text-2xl placeholder-onTrack-smoke text-onTrack-smoke rounded-3xl focus:outline-none w-full mx-6 p-2.5"
              readOnly
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default InsightQuestions
